'use strict';

module.exports = ['$mdDialog',
	function ($mdDialog) {

		return {
			restrict: 'A',
			link: function (scope, element, attributes) {
				element.bind('click', (ev) => {
					let url = element.find('img').attr('src');
					$mdDialog.show({
                        parent: angular.element(document.querySelector('#popupContainer .md-dialog-container')),
						templateUrl: 'thumbnailDialog.ngTemplate',
						locals: { imgUrl: url, element: element },
						controller: 'thumbnailDialogCtrl',
					//	hasBackdrop: true,
						targetEvent: ev,
						multiple:true,
					//	openFrom: element,
					//	closeTo: element,
						clickOutsideToClose: true
					});
				});
			}
		};
	}
];

